import { RESET_ALL as RESET_ON_LOGOUT } from 'redux-store/reducers/common-reducer';
import { createReducer } from 'utils/redux';

import { API, get, put } from 'utils/api';
import { CHANNELS_WITH_METRICS } from 'utils/channels';
import { logError } from 'utils/log';

const { CAMPAIGNS } = API.END_POINTS;

const RECEIVE = 'campaignUISettingsShorlisted/RECEIVE';
const RESET = 'campaignUISettingsShorlisted/RESET';
const LOADING = 'campaignUISettingsShorlisted/LOADING';

import type { CampaignColumnsVisibility, Dispatch } from 'types';

export const AVAILABLE_COLUMNS_FOR_SHORLISTED = [
  'creator_country',
  'creator_age',
  'creator_gender',
  'creator_tier',
  'followers',
  'engagement_rate',
  'price_reco',
  'response_time'
];

const getInitialVisibility = (columnsSetAsFalse?: Array<string>) => ({
  columns: AVAILABLE_COLUMNS_FOR_SHORLISTED.map(type => ({
    type,
    visible: !(columnsSetAsFalse || []).includes(type)
  })),
  channels: CHANNELS_WITH_METRICS.map(type => ({
    type,
    visible: true
  }))
});

const initialState = {
  visibility: getInitialVisibility(),
  visibilityDefault: getInitialVisibility(['creator_age']),
  visibilityIsLoaded: false,
  visibilityisLoading: false
};

export const setLoadingStatus = (status: boolean) => ({
  type: LOADING,
  payload: {
    status
  }
});

export function resetCampaignUISettingsShorlisted() {
  return {
    type: RESET,
    payload: {}
  };
}

export function receiveCampaignUISettingsShorlisted(data: CampaignColumnsVisibility) {
  return {
    type: RECEIVE,
    payload: {
      data
    }
  };
}

export function fetchCampaignUISettingsShorlisted(campaignId: number) {
  const url = CAMPAIGNS.getCampaignUISettingsShorlisted(campaignId);

  return (dispatch: Dispatch) => {
    dispatch(setLoadingStatus(true));
    dispatch(resetCampaignUISettingsShorlisted());

    return get(url, {}, { suppressGlobalNotification: true })
      .then((response) => {
        dispatch(receiveCampaignUISettingsShorlisted(response.data?.state || {}));
        dispatch(setLoadingStatus(false));
      })
      .catch((error) => {
        dispatch(setLoadingStatus(false));
        logError(error);
      });
  };
}

export function saveCampaignUISettingsShorlisted(campaignId: number, data: CampaignColumnsVisibility) {
  return (dispatch: Dispatch) => {
    const url = CAMPAIGNS.saveCampaignUISettingsShorlisted(campaignId);

    return put(url, { data }, { suppressGlobalNotification: true })
      .then(() => {
        dispatch(receiveCampaignUISettingsShorlisted(data));
      })
      .catch((error) => {
        logError(error);
        throw error;
      });
  };
}

export default createReducer<any, any>('campaignUISettingsShorlisted', initialState, {
  [RESET_ON_LOGOUT]: () => initialState,
  [RESET]: () => initialState,
  [RECEIVE]: (state, { data }) => ({
    ...state,
    visibility: {
      ...state.visibility,
      ...data
    },
    visibilityIsLoaded: true
  }),
  [LOADING]: (state, { status }) => ({
    ...state,
    visibilityisLoading: status
  })
});
